import { usePathname } from "next/navigation";
import useStoreKeys from "./useStoreKeys";

const useStorePathname = () => {
	const { store, lang } = useStoreKeys();
	const pathname = usePathname();

	return pathname.replace(`/${store}`, "").replace(`/${lang}`, "");
};

export default useStorePathname;
